import styled from "styled-components"

export const StyledMyOfferSection = styled.section`
  width: 100%;
  position: relative;
  overflow: hidden;
`
